import React, { FC, createRef, forwardRef, useMemo } from "react";
import "../../../assets/css/colors.css";
import "../../../assets/css/size.css";
import "../../../assets/css/string.css";
import { GridHeaderColumnsType, TableComponentProps } from "../../interface";
import SlickGrid1 from "../SlickGrid1";
import type { GridRowBase, QueryShape, SlickgridReactInstanceX, ValidatedColumnDefinition } from "../SlickGrid1";

const TableComponent: FC<TableComponentProps> = forwardRef(
  ({ headerColumns, dataSource, query, remoteDataSource, ...rest }: TableComponentProps, ref) => {
    /*******************
@Purpose : table Component
@Parameter : TableComponentProps
@Author : Techture
 *******************/

    const gridRef = ref || createRef();

    // Convert Syncfusion-style headerColumns to SlickGrid1 columnDefinitions
    const columnDefinitions = useMemo(() => {
      if (!headerColumns) return [];
      return headerColumns.map((col: GridHeaderColumnsType, index: number) => ({
        id: col.field || `col_${index}`,
        field: col.field || "",
        name: col.headerText || "",
        clipMode: col.clipMode || "EllipsisWithTooltip",
        formatter: col.template,
        disableFiltering: col.allowFiltering === false,
        disableSorting: col.allowSorting === false,
      }));
    }, [headerColumns]);

    return (
      // This wrapper is row-type agnostic - it forwards whatever the caller supplies - so each
      // prop is asserted to the grid's row-typed surface at this single boundary. All erased.
      <SlickGrid1
        {...rest}
        ref={gridRef as typeof gridRef & React.Ref<SlickgridReactInstanceX<GridRowBase>>}
        gridOptions={{ forceFitColumns: true }}
        dataset={dataSource as GridRowBase[] | undefined}
        remoteDataSource={remoteDataSource}
        query={query as QueryShape | undefined}
        columnDefinitions={columnDefinitions as typeof columnDefinitions & ValidatedColumnDefinition<GridRowBase>[]}
        infiniteScroll
        disableCheckBoxSelection
      />
    );
  },
);

// KNOWN BUG, preserved verbatim: `defaultProps` on a function component is ignored by React 19, so
// this assignment is already dead. Erased assertion; removing the line would change behaviour only
// if React ever honoured it again.
(TableComponent as typeof TableComponent & { defaultProps: object }).defaultProps = {};
TableComponent.displayName = "TableComponent";
export default TableComponent;
